import { render, staticRenderFns } from "./KeyboardK2Lite.vue?vue&type=template&id=5d7b062a&"
import script from "./KeyboardK2Lite.vue?vue&type=script&lang=js&"
export * from "./KeyboardK2Lite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports